import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './Punchout.scss';
import * as actions from './Punchout.actions';
import * as selectors from './Punchout.selectors';
import { Helmet } from 'react-helmet';
import Favicon from 'react-favicon';
// import { stringifyEqualityCheck, showNotification } from './../../utils';

const Punchout = (props) => {
    /* State to props */
    const fetching = useSelector(selectors.getFetching);
    // const session = useSelector(selectors.getSession, stringifyEqualityCheck);
    // const email = useSelector(selectors.getEmail);
    // const loging = useSelector(selectors.getLoging);

    /* Dispatch to props */
    const dispatch = useDispatch();
    const fetchSession = useCallback((id) => dispatch(actions.fetchSession(id)), [dispatch]);
    const setHistory = useCallback((history) => dispatch(actions.setHistory(history)), [dispatch]);
    // const setEmail = useCallback((value) => dispatch(actions.setEmail(value)), [dispatch]);
    // const loginUser = useCallback(() => dispatch(actions.loginUser()), [dispatch]);

    /* componentDidMount */
    useEffect(() => {
        fetchSession(props.match.params.id);
        setHistory(props.history);
    }, [fetchSession, setHistory, props.match.params.id, props.history]);

    let content = null;
    if (fetching) {
        content = <div className="loading"><i className="fas fa-circle-notch fa-spin" /> Loading data...</div>;
    }
    // if (session && parseInt(session.id) === 16) {
    //     const handleSetEmail = (event) => {
    //         setEmail(event.target.value);
    //     };

    //     const handleLoginClick = () => {
    //         if (!email || email == null || email === '') {
    //             return showNotification('Complete information', 'Enter the email address', 'info');
    //         }
    //         if (email !== 'diego@acmailplex.com') {
    //             return showNotification('Incorrect Email Address', 'The email address you entered is incorrect', 'info');
    //         }

    //         loginUser();
    //     };

    //     let buttonLabel = 'Login';
    //     if (loging) {
    //         buttonLabel = <i className="fas fa-circle-notch fa-spin" />;
    //     }

    //     content = (
    //         <div className="login-container">
    //             Enter the email address:
    //             <input type="text" onChange={handleSetEmail} value={email} />
    //             <div className="text-center">
    //                 <button onClick={handleLoginClick}>{buttonLabel}</button>
    //             </div>
    //         </div>
    //     );
    // }

    return (
        <div className="punchout-container">
            <Favicon url="https://ac-ut-health.s3.amazonaws.com/favicon.ico" />
            <Helmet>
                <title>UT Physicians</title>
            </Helmet>
            {content}
        </div>
    );
};

Punchout.propTypes = {

};

export default Punchout;
